// extracted by mini-css-extract-plugin
export default {"setFont":"CreateButton_setFont__TCJ+S","button":"CreateButton_button__1DcB8"};